import DownloadCategoryList from './DownloadCategoryList';
import DownloadCategoryEdit from './DownloadCategoryEdit';
import DownloadCategoryCreate from "./DownloadCategoryCreate";

export default {
    list: DownloadCategoryList,
    edit: DownloadCategoryEdit,
    create: DownloadCategoryCreate,
};
